import { Grid, TextField, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Divider } from "@components/TimeSlotCst/style";
import InputAdornment from "@mui/material/InputAdornment";
import EuroIcon from "@mui/icons-material/Euro";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

const InfoBar: React.FC<any> = ({ data }) => {
  const theme = useTheme();
  const { t } = useTranslation(["projects-cost-page"]);

  const renderCostField = (label: string, value: number | string) => (
    <Grid item xs={12} sm={4}>
      <Typography sx={{ mb: 1.5, fontWeight: "bold" }}>{label}</Typography>
      <TextField
        type="text"
        size="small"
        value={value || 0}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <EuroIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
        fullWidth
      />
    </Grid>
  );

  return (
    <Grid
      container
      direction="column"
      sx={{
        backgroundColor: theme.palette.background.paper,
        padding: 2,
        width: "100%",
        borderRadius: 1,
        mb: 1,
      }}
    >
      <Accordion
        sx={{
          boxShadow: "none",
          border: "none",
          "&:before": {
            display: "none",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">
            <b>{t("cost_detail")}</b>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Divider theme={theme} sx={{ mb: 2 }} />
          <Grid container spacing={3} sx={{ mb: 3 }}>
            {renderCostField(
              t("cost_to_approve"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.total_pending)),
            )}
            {renderCostField(
              t("cost_internal"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.internal_pending)),
            )}
            {renderCostField(
              t("cost_external"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.external_pending)),
            )}
          </Grid>

          <Divider theme={theme} sx={{ my: 2 }} />

          <Grid container spacing={3}>
            {renderCostField(
              t("cost_approved"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.total_approved)),
            )}
            {renderCostField(
              t("cost_internal"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.internal_approved)),
            )}
            {renderCostField(
              t("cost_external"),
              new Intl.NumberFormat("it-IT", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(Number(data?.external_approved)),
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default InfoBar;
